module.exports = __webpack_public_path__ + "img/TF001.6ad3411d.jpg";